// src/components/CookieBanner.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * Banner de consentimiento de cookies institucional
 * Mensaje conciso, legalmente conforme con Google Consent Mode v2.
 * Destaca el botón "Aceptar" y mantiene sutil "Solo necesarias".
 */
export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('xolofest_cookie_consent');
      if (!consent) {
        setIsVisible(true);
      }
    } catch (e) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem('xolofest_cookie_consent', 'accepted');
    } catch (e) {}

    // Actualización de Google Consent Mode v2
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'cookie_consent_accepted' });
    }

    setIsVisible(false);
  };

  const handleReject = () => {
    try {
      localStorage.setItem('xolofest_cookie_consent', 'rejected');
    } catch (e) {}

    // Asegurar que analytics_storage permanezca denegado
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied'
      });
    }

    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <aside
      className="cookie-banner-wrapper"
      role="region"
      aria-label="Aviso de cookies"
    >
      <div className="container py-3">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-center text-md-start">
          {/* Texto Directo y Sencillo */}
          <div className="cookie-banner-text text-light">
            <span className="fw-normal">
              Usamos cookies para mejorar tu experiencia y analizar las visitas del sitio. Conoce más en nuestra{' '}
            </span>
            <Link
              to="/politica-cookies"
              className="text-white text-decoration-underline fw-semibold hover-red"
            >
              Política de Cookies
            </Link>
            .
          </div>

          {/* Botones de Acción (Aceptar Destacado / Solo Necesarias Sutil) */}
          <div className="d-flex align-items-center justify-content-center gap-2 flex-shrink-0">
            <button
              type="button"
              className="btn btn-link text-light opacity-75 small text-decoration-none px-3 py-2 hover-opacity-100"
              onClick={handleReject}
            >
              Solo necesarias
            </button>
            <button
              type="button"
              className="btn btn-xolo-primary px-4 py-2 fw-bold text-uppercase fs-6 shadow-sm"
              onClick={handleAccept}
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}
